import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			inputAdornment: {
				background: theme.palette.common.white,
				height: "100%",
				padding: 1,
				borderTopLeftRadius: 5,
				borderBottomLeftRadius: 5
			},
			customInput: {
				color: theme.palette.primary.contrastText,
				"& > .MuiInput-root": {
					border: `1px solid ${theme.palette.info.main}`,
					height: 35,
					background: theme.palette.info.main,
					borderRadius: 4
				},
				height: "100%",
				width: "100%",
				"& > div > input": {
					color: theme.palette.primary.contrastText,
					height: 37,
					backgroundColor: theme.palette.grey["A100"],
					fontSize: "14px !important",
					lineHeight: "21px",
					"@media only screen and (max-width: 768px)": {
						fontSize: 14,
						lineHeight: "19px"
					}
				},
				"& > div > textarea": {
					color: theme.palette.primary.contrastText,
					margin: 20,
					backgroundColor: theme.palette.grey["A100"]
				},
				"& > .MuiInput-underline:before": {
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`,
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					content: "none",
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`
				},
				"& > div > .MuiSelect-select.MuiSelect-select": {
					color: theme.palette.primary.contrastText,
					textAlign: "initial",
					marginLeft: 15
				}
			}
		}),
	{
		name: "InputSearchProduct",
		index: 1
	}
);

export default useStyles;
